import { Component } from '@angular/core';
import * as interfaceSelectors from "../../state/interface/interface.selector";
import {Store} from "@ngrx/store";
import * as ChatSelectors from "../../state/chats/chat.selector";
import * as AuthSelectors from "../../state/auth/auth.selector";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {interfaceActions} from "../../state/interface/interface.actions";
import {config} from "rxjs";

@Component({
  selector: 'context-menu',
  standalone: true,
  imports: [
    RouterOutlet
  ],
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss'
})
export class ContextMenuComponent {
  contextMenuOpen = true
  positionX = 500
  positionY = 500

  constructor(
      private store: Store,
      private route: ActivatedRoute,
      private router: Router
  ) {
    this.route.queryParams.subscribe(params => {
      this.positionX = params["posX"] || 500;
      this.positionY = params["posY"] || 500;
    });
    this.store.select(interfaceSelectors.selectContextMenuIsOpen).subscribe((isOpen) => {
      this.contextMenuOpen = isOpen;
    })
  }

  closeContextMenu() {
    this.store.dispatch(interfaceActions.closeContextMenu())
    this.router.navigate( [{outlets: {'context-menu': null}}], { queryParamsHandling: 'preserve' })
  }
}
